import React from 'react';
import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `<h1 class="h-section mb-6">Accreditation</h1>

<p>St. Andrews World School, Sonipat is recognised by the CBSE board and offers holistic learning experiences to the students. The curriculum provided is CBSE board and the medium of instruction is English. Our faculty and non-faculty members are highly talented professionals who ensure that bright minds are equally equipped with the knowledge and tools to prosper in the real world.</p>

<p>Our school follows the CBSE curriculum which is designed to promote holistic development, critical thinking, and practical knowledge. We believe in nurturing students who are not only academically proficient but also socially responsible and emotionally balanced.</p>`;

const Accreditation = () => {
  const title = 'Accreditation';
  const pageData = usePage('accreditation', { content: DEFAULT_CONTENT });

  return (
    <>
      <SEO
        title={title}
        description="Accreditation details of St. Andrews World School, Sonipat."
        keywords="Accreditation, SAWS Sonipat, St Andrews World School Sonipat"
      />

      <section className="page-hero">
        {!pageData.loading && (
        <img
            src={pageData.bannerImage || '/images/page-banners/curricullam-infrastructure.jpg'}
            alt={title}
            className="page-hero-img"
            loading="eager"
          />
        )}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="section bg-white">
        <div className="container">
          <div className="card p-7 md:p-10">
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default Accreditation;